import React, { ReactNode } from 'react'
import type { ContainerBlock as BlockProps } from '@/payload-types'
import { Container as ContainerComponent } from '@/components/Container'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import { ClassValue } from 'clsx'

// Legacy fallback: docs from before the schema upgrade carry `narrow: bool`
// and a freeform `padding: text` instead of `maxWidth` + `paddingSize`. The
// 20260427_containers_narrow_to_maxwidth migration converts narrow but
// can't safely auto-convert freeform padding strings, so the component
// keeps reading both. Prefer the new fields when present.
function resolveMaxWidth(maxWidth?: string | null, narrow?: boolean | null): string | undefined {
  if (maxWidth) return maxWidth
  if (narrow) return 'narrow'
  return undefined
}

export const ContainerBlock: React.FC<
  BlockProps & { children?: ReactNode; className?: ClassValue }
> = ({ layout, center, narrow, padding, maxWidth, paddingSize, children, className }) => {
  return (
    <ContainerComponent
      center={center || undefined}
      maxWidth={resolveMaxWidth(maxWidth, narrow)}
      paddingSize={paddingSize || undefined}
      legacyPadding={padding || undefined}
      className={className}
    >
      {children}
      <RenderBlocks blocks={layout ?? []} />
    </ContainerComponent>
  )
}
